export const RequestMethod = Object.freeze({
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
  HEAD: "HEAD",
  OPTIONS: "OPTIONS",
});

export const AuthType = Object.freeze({
  NONE: "none",
  BASIC: "basic",
  BEARER: "bearer",
  API_KEY: "apiKey",
  OAUTH2: "oauth2",
  USER_TOKEN: "userToken", // signed in user token
});

export const BodyType = Object.freeze({
  NONE: "none",
  RAW: "raw",
  FORM: "form",
  MULTIPART: "multipart",
});

export const BodyContentType = Object.freeze({
  JSON: "application/json",
  XML: "application/xml",
  TEXT: "text/plain",
  HTML: "text/html",
  FORM: "application/x-www-form-urlencoded",
  MULTIPART: "multipart/form-data",
  JAVASCRIPT: "application/javascript",
  OCTET_STREAM: "application/octet-stream",
});

export const GrantType = Object.freeze({
  CLIENT_CREDENTIALS: "client_credentials",
  PASSWORD: "password",
  AUTH_CODE: "authorization_code",
});

export const SourceType = Object.freeze({
  FIXED: "fixed",
  FIELD: "field",
  ATTACHMENT: "attachment",
  CREDENTIAL: "credential",
  SERVER_VARIABLE: "serverVariable",
});

export const ServerVariableExpiryOption = Object.freeze({
  ONE_MINUTE: "60",
  FIVE_MINUTES: "300",
  TEN_MINUTES: "600",
  FIFTEEN_MINUTES: "900",
  THIRTY_MINUTES: "1800",
  ONE_HOUR: "3600",
});

export const DefaultValues = Object.freeze({
  API_KEY_NAME: "X-API-Key",
  TIMEOUT: 30000,
  MAX_RETRIES: 3,
  MAX_REDIRECTS: 5,
});

export const ResponseMode = Object.freeze({
  STANDARD: "standard",
  TEST: "test",
  SECURE: "secure",
});

// Default item template for request operations.
// Used for adding new items for QueryParams, Headers, Environment Variables
// to the request (in the UI)
const ITEM_TEMPLATE = {
  key: "",
  value: "",
  testValue: "", // only used in design mode
  enabled: true,
  source: SourceType.FIXED,
  fieldId: "",
  credentialId: ""
};

export const DefaultConfigs = Object.freeze({
  header: { ...ITEM_TEMPLATE },
  queryParam: { ...ITEM_TEMPLATE },
  urlEncoded: { ...ITEM_TEMPLATE },
  formData: {
    ...ITEM_TEMPLATE,
    testFile: null, // only used in design mode
  },
  envVar: { ...ITEM_TEMPLATE },
  mapping: {
    responsePath: "",
    mapTo: SourceType.FIELD,
    serverVariableName: "",
    fieldId: "",
  }
});
